import { cn } from '#app/utils/misc.tsx'

/**
 * Person hues are fixed in circle order (plan §1.1) so the same person has
 * the same colour in the Oyka app and the stal app; two extra hues serve
 * the stable. `personHue(index)` is the circle-order lookup; `personHue(name)`
 * is the stable fallback (a hash of the name) for people without an index.
 */
export const PERSON_HUES = [
	'#4a7cb0',
	'#9b6b9e',
	'#c07a4a',
	'#5b8a5b',
	'#607080',
	'#3e9e99',
] as const

export const STAL_HUES = ['#8a6d4f', '#3e7c8f'] as const

export const ALL_HUES = [...PERSON_HUES, ...STAL_HUES] as const

function hashName(name: string) {
	let h = 5381
	for (const ch of name.trim().toLowerCase()) {
		h = (h * 33) ^ ch.codePointAt(0)!
		h >>>= 0
	}
	return h
}

export function personHue(indexOrName: number | string): string {
	if (typeof indexOrName === 'number') {
		const i = Math.abs(Math.trunc(indexOrName))
		return ALL_HUES[i % ALL_HUES.length]!
	}
	return PERSON_HUES[hashName(indexOrName) % PERSON_HUES.length]!
}

export function OyAvatar({
	name,
	hue,
	size = 26,
	me,
	className,
}: {
	name: string
	/** a hex colour (from personHue); defaults to the name's stable hue */
	hue?: string
	size?: 24 | 26 | 28 | 34 | 36 | 44
	/** the operator's own avatar: accent-soft tile, accent ink */
	me?: boolean
	className?: string
}) {
	const initial = name.trim().charAt(0).toUpperCase()
	return (
		<span
			className={cn(
				'oy-avatar',
				size !== 26 && `size-${size}`,
				me && 'me',
				className,
			)}
			style={me ? undefined : { background: hue ?? personHue(name) }}
			aria-hidden="true"
		>
			{initial}
		</span>
	)
}
